import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-backup-details',
  templateUrl: './backup-details.component.html',
  styleUrl: './backup-details.component.scss',
  standalone: false
})
export class BackupDetailsComponent {

  details: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public matdialogRef: MatDialogRef<BackupDetailsComponent>) {
    this.details = data.details;
    let createdAt = new Date(this.details.dbDetails.createdAt);
    let expirationDate = new Date(this.details.dbDetails.expirationDate);
    let days = Math.floor((Date.UTC(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()) - Date.UTC(createdAt.getFullYear(), createdAt.getMonth(), createdAt.getDate()) ) /(1000 * 60 * 60 * 24));
    this.details.dbDetails.expiryDays = days;
    this.details.typeTag = this.details.from?.type?.toLowerCase()?.includes('postgresql') ? 'PostgreSQL' : '';
  }

  // to redirect the user to tickets page in new tab
  ticketNumberClick(ticketNumber): void {
    const url = `https://itsm-servicedesk.temenos.com/browse/${ticketNumber}`;
    window.open(url, '_blank');
  }
}
